/* istanbul ignore file */
import { stringify } from "query-string";

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { IAccountsRequest, IAccountsResponse, IAccountsToGrantRoleRequest, IAccountsToGrantRoleResponse } from "./Account.api.types";

export const getAccounts = async (request: IAccountsRequest) => {
  return (
    await getClientFor(mainApi.name).get<IAccountsResponse[]>(`/organizations/accounts/tenants/${request.tenantId}`, {
      params: {
        filter: request.filter
      }
    })
  ).data;
};

export const getAccountsToGrantRole = async (request: IAccountsToGrantRoleRequest) => {
  return (
    await getClientFor(mainApi.name).get<IAccountsToGrantRoleResponse[]>(`/security-roles/${request.securityRoleId}/tenants/accounts/`, {
      params: {
        filter: request.filter,
        tenantId: request.tenantId
      },
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};
